import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import ToolManagmentCard from "../../../../../../../common/element/Card/ToolManagmnetCard";
import { getCompanyStats, clearCompanyStats } from "../../../../../../../redux/Companies/companiesSlice";
import {
  selectCompanyStatsData,
  selectCompanyStatsLoading,
  selectCompanyStatsError,
} from "../../../../../../../redux/Companies/companiesSelector";
import ThreeDotBouncingLoader from "../../../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";

const OnboardingStats = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const statsData = useSelector(selectCompanyStatsData);
  const loading = useSelector(selectCompanyStatsLoading);
  const error = useSelector(selectCompanyStatsError);
 const searchParams = new URLSearchParams(location.search);
  const companyId = searchParams.get('companyId');
  useEffect(() => {
    // Fetch company stats when component mounts or companyId changes
    if (companyId) {
      dispatch(getCompanyStats(companyId));
    }

    // Cleanup function to clear stats when component unmounts
    return () => {
      dispatch(clearCompanyStats());
    };
  }, [companyId, dispatch]);

  // Default/fallback data structure
  const displayData = {
    numberOfEmployees: statsData?.number_of_employees || "0",
    numberOfBatches: statsData?.number_of_batches || "0",
    totalSessionsConducted: statsData?.total_sessions_conducted || "0",
    assignmentIssued: statsData?.assignments_attached_to_company || "0",
    totalSessionsInPipeline: statsData?.total_sessions_in_pipeline || "0",
    resourcesIssued: statsData?.documents_attached_to_company || "0",
    employeesSessionsConducted: statsData?.employee_sessions_conducted || "0",
    managementSessionsConducted: statsData?.management_sessions_conducted || "0",
  };

  return (
    <ToolManagmentCard>
      <div className="pb-4 border-b border-gray-200">
        <h2 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828] text-start">
          Onboarding Data
        </h2>
      </div>

      <div className="py-6 space-y-6">
        {/* Loading State */}
        {loading && (
          <div className="text-center py-4">
         <ThreeDotBouncingLoader/>
          </div>
        )}

        {/* Error State */}
        {error && !loading && (
          <div className="text-center py-4">
            <p className="font-lato text-[14px] text-red-500">Error: {error}</p>
          </div>
        )}

        {/* Stats Grid */}
        {!loading && (
          <div className="grid grid-cols-2 gap-x-6 gap-y-4">
            <div className="text-start">
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">
                Number of Employees
              </label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">
                {displayData.numberOfEmployees}
              </p>
            </div>

            <div className="text-start">
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">
                Number of batches
              </label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">
                {displayData.numberOfBatches}
              </p>
            </div>

            <div className="text-start">
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">
                Total Sessions Conducted
              </label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">
                {displayData.totalSessionsConducted}
              </p>
            </div>

            <div className="text-start">
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">
                Assignment Issued
              </label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">
                {displayData.assignmentIssued}
              </p>
            </div>

            <div className="text-start">
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">
                Total Sessions in Pipeline
              </label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">
                {displayData.totalSessionsInPipeline}
              </p>
            </div>

            <div className="text-start">
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">
                Documents Issued
              </label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">
                {displayData.resourcesIssued}
              </p>
            </div>

            <div className="text-start">
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">
                Employees Sessions Conducted
              </label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">
                {displayData.employeesSessionsConducted}
              </p>
            </div>

            <div className="text-start">
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">
                Management Sessions Conducted
              </label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">
                {displayData.managementSessionsConducted}
              </p>
            </div>
          </div>
        )}
      </div>
    </ToolManagmentCard>
  );
};

export default OnboardingStats;